module.exports = __webpack_public_path__ + "03_short_black.61510da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_short_black.png
// module id = 50o7
// module chunks = 0